import axios from "axios";

import { RecordsListItem } from "fe-shared/src/types/common";

export const getRequestNotes = (
  requestNumber: string
): Promise<RecordsListItem[]> =>
  axios
    .get<RecordsListItem[]>(`requests/${requestNumber}/notes`)
    .then((res) => res.data);

export const addRequestNote = (
  requestNumber: string,
  text: string
): Promise<RecordsListItem> =>
  axios
    .post<RecordsListItem>(`requests/${requestNumber}/notes`, { text })
    .then((res) => res.data);
